import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product: string;
  text: string;
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: TestimonialProps) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 md:p-7" data-id="element-314" data-mp="3azje1xiuikc7">
      <div className="mb-4 flex items-center gap-3" data-id="element-315" data-mp="36zip3iy4eqqw">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-gold/55 bg-brand-surfaceLight font-serif font-bold text-brand-forest" data-id="element-316" data-mp="36wwh5i7bi985">
          {initials}
        </div>
        <div data-id="element-317" data-mp="2s1q8engu7wb4">
          <div className="flex text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-318" data-mp="2s1ymujslz9of">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-319" data-mp="qall23lxthwl" />)}
          </div>
          <p className="mt-1 font-semibold text-brand-ink" data-id="element-320" data-mp="m5kmoqccuxdh">{name}</p>
          <p className="text-xs text-brand-muted" data-id="element-321" data-mp="m2ood0wli6oi">
            {location} · {product}
          </p>
        </div>
      </div>
      <p className="font-serif text-base leading-relaxed text-brand-text" data-id="element-322" data-mp="c6bthzpbdms6">
        “{text}”
      </p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pt-6" data-id="element-323" data-mp="zysdwgwixqun">
      <div className="mx-auto max-w-3xl" data-id="element-324" data-mp="14w296d6lgwqe">
        <TestimonialCard initials="MG" name="María G." location="Córdoba" product="Terapeuta en Medicina Tradicional China" text="Por primera vez tengo una herramienta visual que puedo abrir en consulta y mostrarle al paciente exactamente qué punto voy a trabajar y por qué. La autoridad que transmite es inmediata." data-id="element-325" data-mp="14ur7ciwplz1x" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Terapeuta holística',
    text: 'Por primera vez tengo un sistema completo y visual para aplicar digitopuntura con criterio clínico real. Mis pacientes ven exactamente qué punto trabajo y por qué. La confianza que genera es total.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Especialista en MTC',
    text: 'El nivel de detalle técnico de cada ficha es impresionante. Tiene la claridad de un material para principiantes y la profundidad que exige un especialista. No existe nada igual en español.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta en formación',
    text: 'Recién empezaba y el Botiquín me dio la estructura y la seguridad que necesitaba desde el primer paciente. Los bonos de los 5 Elementos y Auriculoterapia solos valen todo el pack.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Terapeuta holístico',
    text: 'El bono de Farmacopea Externa me abrió un nicho que no imaginaba. Ahora combino aceites esenciales con los puntos del botiquín y mis sesiones tienen una profundidad completamente diferente.'
  }];
  return <Section data-id="element-326" data-mp="3gecbbt0g8a58">
      <div className="mb-10 text-center" data-id="element-327" data-mp="2jqo9ymolww8d">
        <h2 className="font-display text-3xl font-bold text-brand-ink md:text-4xl" data-id="element-328" data-mp="2jrpncxt3hut9">
          LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-329" data-mp="2sqkr838o2ste">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-330" data-mp="2ximbabc2tntz" />)}
      </div>
    </Section>;
}